module.exports = "<!-- tela de bloqueio -->\r\n<div class=\"wrapper\">\r\n    <div class=\"content-wrapper\">\r\n        <div class=\"container-fluid\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/content/content-layout.component.html
// module id = ./src/app/layouts/content/content-layout.component.html
// module chunks = main